import React from 'react'
import './NotFound.css'

function NotFound() {
  return (
    <div className="not-found-component">
      <div className="not-found-container"> 
        <div className="not-found-one">
           <p>404</p>
        </div>
      <div className="not-found-two">
        <p> Page Not Found </p>
          </div>
            </div>
              <div className="not-found-three">
               <h3> ZeroOne Learning  </h3>
           </div>
      </div>
    )
}

export default NotFound